// src/components/products/DownloadsSection.jsx
import React from "react";
import { DocumentIcon } from "@heroicons/react/24/outline";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { useProductTheme } from "../../contexts/ProductThemeContext";
import { getBrandThemeClasses } from "../../utils/brandThemeClasses";

const DownloadsSection = ({ title, files, safeText }) => {
  const { themeId } = useProductTheme();
  const themeClasses = getBrandThemeClasses(themeId);

  if (!title) return null;

  const hasFiles = files && files.length > 0;

  return (
    <div>
      <div className="product-panel-elevated rounded-3xl shadow-2xl overflow-hidden">
        <div className="product-panel-header">
          <h2>{safeText(title)}</h2>
        </div>

        <div className="p-6 sm:p-8 lg:p-10">
          {hasFiles ? (
            <div className="space-y-4 sm:space-y-6">
              {files.map((file, index) => {
                const fileUrl = file.download_file?.url || file.url;
                const rawTitle = file.download_title;
                const fileTitle =
                  safeText(rawTitle) || `Download ${index + 1}`;
                const isPDF =
                  fileUrl && fileUrl.toLowerCase().endsWith(".pdf");
                const isOddRow = index % 2 === 0;

                const FileIcon = isPDF ? BsFillFileEarmarkPdfFill : DocumentIcon;
                const fileIconClass = isPDF
                  ? "text-red-600"
                  : themeClasses.cardFallbackIcon;

                return (
                  <button
                    key={file.id || index}
                    type="button"
                    onClick={() => {
                      if (fileUrl) {
                        window.open(
                          fileUrl,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }
                    }}
                    className={`group w-full backdrop-blur-md rounded-xl border shadow-lg p-4 transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl md:p-6 flex items-center gap-4 text-left ${
                      isOddRow
                        ? themeClasses.cardRowOdd
                        : themeClasses.cardRowEven
                    }`}
                  >
                    <FileIcon
                      className={`h-8 w-8 flex-shrink-0 ${fileIconClass}`}
                    />
                    <div className="min-w-0 flex-1">
                      <h3
                        className={`text-base font-semibold text-gray-900 sm:text-lg md:text-xl ${themeClasses.titleHover} line-clamp-2 transition-colors duration-200`}
                      >
                        {fileTitle}
                      </h3>
                      {isPDF && (
                        <p className="mt-1 text-xs text-gray-500 sm:text-sm">
                          PDF Document
                        </p>
                      )}
                    </div>
                    <div className="flex-shrink-0">
                      <div className="product-btn-icon flex h-8 w-8 items-center justify-center rounded-full transition-colors duration-200 sm:h-10 sm:w-10">
                        <svg
                          className="h-4 w-4 sm:h-5 sm:w-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14 3h7m0 0v7m0-7L10 14"
                          />
                        </svg>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          ) : (
            <div className="py-8 text-center text-[color:var(--pt-fg)]/80">
              <p>No download files available.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadsSection;
